module.exports = __webpack_public_path__ + "img/registration.b75b2bc3.png";